// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapLongText--EO1bB {
  overflow-wrap: break-word;
  word-wrap: break-word;
  -ms-word-break: break-all;
  /* This is the dangerous one in WebKit, as it breaks things wherever */
  word-break: break-all;
  /* Instead use this non-standard one: */
  word-break: break-word;
  /* Adds a hyphen where the word breaks, if supported (No Blink) */
  -ms-hyphens: auto;
  -moz-hyphens: auto;
  -webkit-hyphens: auto;
  hyphens: auto;
}

.textCenter--I7u9a {
  text-align: center;
}

.rightShadow--dnM8z {
  box-shadow: 3px 0 3px rgba(0, 0, 0, 0.1);
}

.header--MmdyH {
  background-color: #002984;
  box-shadow: 0 0 5px rgb(0, 0, 0);
  position: relative;
  display: flex;
  align-items: center;
  color: #fff;
}
.header--MmdyH .main--hMy7R {
  display: flex;
  gap: 16px;
  padding-left: 60px;
  padding-right: 60px;
  padding-top: 8px;
  padding-bottom: 8px;
  align-items: center;
  overflow: hidden;
}
.header--MmdyH .displayName--uFQRo {
  font-size: 20px;
  font-weight: 500;
  padding: 0;
  margin: 0;
}
.header--MmdyH .typingIndicator--n6F__,
.header--MmdyH .participants--vn1_z {
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.header--MmdyH .typingIndicator--n6F__ {
  color: #ffab00;
}
.header--MmdyH .backButton--N4NQ4,
.header--MmdyH .closeButton--qRy6x {
  color: #fff;
  position: absolute;
  display: block;
}
.header--MmdyH .backButton--N4NQ4 {
  left: 8px;
}
.header--MmdyH .closeButton--qRy6x {
  right: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/global.scss","webpack://./src/app/widgets/chatHeaders/a24GroupHeader/a24GroupHeader.scss"],"names":[],"mappings":"AAeA;EACE,yBAAA;EACA,qBAAA;EACA,yBAAA;EAEA,sEAAA;EACA,qBAAA;EAEA,uCAAA;EACA,sBAAA;EAEA,iEAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,aAAA;ACjBF;;ADoBA;EACE,kBAAA;ACjBF;;ADoBA;EACE,wCAAA;ACjBF;;AAlBA;EACE,yBDCuB;ECAvB,gCAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAqBF;AAnBE;EACE,aAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AAqBJ;AAlBE;EACE,eAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;AAoBJ;AAjBE;;EAEE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAmBJ;AAhBE;EACE,cDhCkB;ACkDtB;AAfE;;EAEE,WAAA;EACA,kBAAA;EACA,cAAA;AAiBJ;AAdE;EACE,SAAA;AAgBJ;AAbE;EACE,UAAA;AAeJ","sourcesContent":["@import '~@material/theme/_color-palette.scss';\n@import '~@material/theme/_variables.scss';\n\n$mdc-theme-primary: #3f51b5;\n$mdc-theme-primary-light: #757de8;\n$mdc-theme-primary-dark: #002984;\n$mdc-theme-secondary: #ffab00;\n$mdc-theme-secondary-light: #ffdd4b;\n$mdc-theme-secondary-dark: #c67c00;\n$mdc-theme-background: #f6f6f6;\n$mdc-theme-surface: #fff;\n$ember-background-color: #eee;\n\n// global classes\n\n:local(.wrapLongText) {\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n  -ms-word-break: break-all;\n\n  /* This is the dangerous one in WebKit, as it breaks things wherever */\n  word-break: break-all;\n\n  /* Instead use this non-standard one: */\n  word-break: break-word;\n\n  /* Adds a hyphen where the word breaks, if supported (No Blink) */\n  -ms-hyphens: auto;\n  -moz-hyphens: auto;\n  -webkit-hyphens: auto;\n  hyphens: auto;\n}\n\n:local(.textCenter) {\n  text-align: center;\n}\n\n:local(.rightShadow) {\n  box-shadow: 3px 0 3px rgba(0, 0, 0, 0.1);\n}\n","@import '../../../global.scss';\n@import '~@material/drawer/_variables.scss';\n\n:local(.header) {\n  background-color: $mdc-theme-primary-dark;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 11);\n  position: relative;\n  display: flex;\n  align-items: center;\n  color: #fff;\n\n  :local(.main) {\n    display: flex;\n    gap: 16px;\n    padding-left: 60px;\n    padding-right: 60px;\n    padding-top: 8px;\n    padding-bottom: 8px;\n    align-items: center;\n    overflow: hidden;\n  }\n\n  :local(.displayName) {\n    font-size: 20px;\n    font-weight: 500;\n    padding: 0;\n    margin: 0;\n  }\n\n  :local(.typingIndicator),\n  :local(.participants) {\n    font-size: 14px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  :local(.typingIndicator) {\n    color: $mdc-theme-secondary;\n  }\n\n  :local(.backButton),\n  :local(.closeButton) {\n    color: #fff;\n    position: absolute;\n    display: block;\n  }\n\n  :local(.backButton) {\n    left: 8px;\n  }\n\n  :local(.closeButton) {\n    right: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapLongText": `wrapLongText--EO1bB`,
	"textCenter": `textCenter--I7u9a`,
	"rightShadow": `rightShadow--dnM8z`,
	"header": `header--MmdyH`,
	"main": `main--hMy7R`,
	"displayName": `displayName--uFQRo`,
	"typingIndicator": `typingIndicator--n6F__`,
	"participants": `participants--vn1_z`,
	"backButton": `backButton--N4NQ4`,
	"closeButton": `closeButton--qRy6x`
};
export default ___CSS_LOADER_EXPORT___;
